import { encode, decode } from 'js-base64';
import { isObject, isEmptyObject } from './types';

/**
 * Object对象与base64 string转换逻辑封装
 */
class ObjectToBase64 {
  constructor() {
    this.state = {};
    this.encodeValue = '';
  }

  _stringify(data) {
    return JSON.stringify(data);
  }

  _parse(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return {};
    }
  }

  setObject(data) {
    if (!isObject(data)) {
      return false;
    }
    this.state = data;
    this.encodeValue = encode(this._stringify(this.state));
    return true;
  }

  _decode(base64Str) {
    if (typeof base64Str !== 'string') {
      return decode('');
    }
    try {
      return decode(base64Str);
    } catch (e) {
      return decode('');
    }
  }

  setBase64String(base64Str) {
    let data = this._parse(this._decode(base64Str));
    if (isEmptyObject(data)) {
      return false;
    }
    return this.setObject(data);
  }

  updateObject(data) {
    if (!isObject(data)) {
      return false;
    }
    this.state = Object.assign({}, this.state, data);
    return this.setObject(this.state);
  }

  isValidBase64Str(base64Str) {
    let data = this._parse(this._decode(base64Str));
    return !isEmptyObject(data);
  }

  getBase64Str() {
    return this.encodeValue;
  }

  getObject() {
    return this._parse(this._decode(this.encodeValue));
  }

  clear() {
    this.state = {};
    this.encodeValue = '';
  }
}

export default ObjectToBase64;
